import * as actionTypes from "../actions/types";

const initialState = {
  favorites: {},
};

const userDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_FAVORITE: {
      const menuItemId = action.payload;
      const newFavorites = { ...state.favorites };
      if (newFavorites[menuItemId]) {
        delete newFavorites[menuItemId];
      } else {
        newFavorites[menuItemId] = true;
      }
      return { ...state, favorites: newFavorites };
    }
  }
  return state;
};

export default userDataReducer;
